module.exports = __webpack_public_path__ + "img/IMARI_S.4ae17808.png";